import { Dd, Div, Dl, Dt, Flex, H3 } from '@dnb/eufemia';
import { HelpProps } from '@dnb/eufemia/components/help-button/HelpButtonInline';

export const additionalSettingsHelpContent: HelpProps = {
  content: (
    <Flex.Stack innerSpace={false}>
      <Flex.Stack gap="x-small">
        <H3>Environment</H3>
        <Div>
          In the context of access management <b>environment</b> maps to the different CIAM authorization servers.
        </Div>
        <Dl layout="grid" top="x-small">
          <Dt>Test</Dt>
          <Dd>Maps to CIAM uat.</Dd>
          <Dt>Live</Dt>
          <Dd>Maps to CIAM production.</Dd>
        </Dl>
      </Flex.Stack>
      <Flex.Stack gap="x-small">
        <H3>Access available</H3>
        <Div>Determines whether access can be requested towards the given environment.</Div>
        <Dl layout="grid" top="x-small">
          <Dt>Yes</Dt>
          <Dd>Access can be requested.</Dd>
          <Dt>No</Dt>
          <Dd>Access cannot be requested.</Dd>
        </Dl>
      </Flex.Stack>
      <Flex.Stack gap="x-small">
        <H3>Approval type</H3>
        <Div>Approval type determines how access requests will be processed in the given environment.</Div>
        <Dl layout="grid">
          <Dt>Automatic</Dt>
          <Dd>Access requests will be automatically approved.</Dd>
          <Dt>ServiceNow</Dt>
          <Dd>Access requests will be sent to ServiceNow for the approval process.</Dd>
        </Dl>
      </Flex.Stack>
    </Flex.Stack>
  ),
  outset: false,
};
